import React, { useState, useEffect } from "react";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import { IconButton, Typography } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClearIcon from "@mui/icons-material/Clear"; // Cross button

const SelectBoxField = ({ label, options = [], isRequired, onChange, onChangeValue, value, sx, ClearFunc, isloading, type, isShowCross = true, noOptionsText }) => {
    const [open, setOpen] = useState(false);
    const [selectedOption, setSelectedOption,] = useState(null);

    useEffect(() => {
        // If the value is an object (i.e., a valid option), use it directly
        if (typeof value === "object" && value !== null) {
            setSelectedOption(value);
        }
        // // If the value is a date, format it properly
        // else if (Object.prototype.toString.call(value) === "[object Date]" && !isNaN(value)) {
        //     setSelectedOption({ label: value.toDateString(), value });
        // } 

    }, [value, options]);

    const handleChange = (_, newValue) => {
        if (type === "date") {
            setSelectedOption(newValue);
            onChange?.(newValue ? newValue.value : "");

        } else {
            if (newValue) {
                setSelectedOption(newValue);
                onChange?.(newValue.id);
                onChangeValue?.(newValue)
            }
        }

    };

    const handleClear = (event) => {
        event.stopPropagation();
        setSelectedOption(null);
        onChange?.("");
        onChangeValue?.({})
        if (ClearFunc) ClearFunc();

    };

    return (
        <FormControl fullWidth>
            <Autocomplete
                id="autocomplete"
                options={isloading ? [] : options}
                getOptionLabel={(option) => option.label}
                value={selectedOption}
                onChange={handleChange}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                // filterOptions={(opts) => opts}
                filterOptions={(options, { inputValue }) =>
                    options.filter(option => option.label.toLowerCase().includes(inputValue.toLowerCase()))
                }
                isOptionEqualToValue={(option, val) => typeof value === "object" ? option.value === val?.value : option.id === val?.id}
                loading={isloading}
                sx={{
                    backgroundColor: "#F7F7F7",
                    borderRadius: "12px",
                    "& fieldset": { border: "none" },
                    "& .MuiOutlinedInput-root .MuiAutocomplete-input": { padding: "0" },
                    "& .MuiInputBase-input": { fontSize: "12px" },
                    ...sx
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={label}
                        required={isRequired}
                        slotProps={{
                            input: {
                                ...params.InputProps,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {selectedOption && isShowCross && (
                                            <IconButton onClick={handleClear} size="small">
                                                <ClearIcon sx={{ fontSize: "18px" }} />
                                            </IconButton>
                                        )}
                                        <IconButton onClick={() => setOpen(!open)} size="small">
                                            <ArrowDropDownIcon sx={{ fontSize: "24px" }} />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }
                        }}
                    />
                )}
                renderOption={(props, option) => (
                    <li {...props}>{option.label}</li>
                )}
                noOptionsText={isloading ? <Typography variant="h6">Loading......</Typography> : <Typography variant="h6">{noOptionsText || "No Option"}</Typography>}
            />
        </FormControl>
    );
};

export default SelectBoxField;
